/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import _t from 'i18n!nls/account-profile';

const styles = {
  // Asterisk was done in css instead of JSX to avoid CDS conflicting styles that were causing a11y and testing issues
  // due to it adding CDS asterisk styling
  asterisk: css`
    .required::before {
      content: ' *';
      color: red;
    }
  `,
};

type PropsFromCaller = {
  labelComponent?: React.ReactElement;
  disableRequiredGatingLogic?: boolean;
  testId?: string;
  customCss?: Interpolation<Theme>;
};

const RequiredFieldLabel = ({ labelComponent, disableRequiredGatingLogic, testId, customCss }: PropsFromCaller) => {
  return (
    <div css={customCss} data-testid={testId}>
      {labelComponent}
      {disableRequiredGatingLogic && (
        <span css={styles.asterisk}>
          <span className="required" aria-hidden={true} />
          <Typography2 component="span" variant="subtitleMedium" color="supportText">
            <i>{_t(' (Required)')}</i>
          </Typography2>
        </span>
      )}
    </div>
  );
};

export default RequiredFieldLabel;
